import { Box, Card, CardHeader, Stack, Table, TableBody, TableCell, TableRow } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import FlagIcon from '@/components/dataDisplay/FlagIcon'
import CustomCardContent from '@/components/layouts/CustomCardContent'

const StyledTableRow = styled(TableRow)(() => ({
  '.MuiTableCell-root': {
    border: 'none',
  },
}))

type RegulationObjectCardProps = {
  countryCode: string
  regulationObjectCode: string
}

const RegulationObjectDetailTable = ({
  countryCode,
  regulationObjectCode,
}: {
  countryCode: string
  regulationObjectCode: string
}) => {
  const { t } = useTranslation()

  return (
    <>
      <CardHeader sx={{ paddingX: 0 }} title={t('portfolio_hierarchy.regulation_object.general_information')} />
      <Box display="flex">
        <Table
          aria-label={t('portfolio_hierarchy.regulation_object.general_information')}
          size="small"
          sx={{ width: '100%' }}
        >
          <TableBody>
            <StyledTableRow>
              <TableCell sx={{ width: '25%' }}>
                <CustomTypography color="grey.500" variant="caption">
                  {t('portfolio_hierarchy.regulation_object.code')}
                </CustomTypography>
              </TableCell>
              <TableCell sx={{ width: '25%' }}>
                <CustomTypography sx={{ lineHeight: 'inherit' }} variant="inherit">
                  {regulationObjectCode}
                </CustomTypography>
              </TableCell>
              <TableCell sx={{ width: '25%' }}>
                <CustomTypography color="grey.500" variant="caption">
                  {t('portfolio_hierarchy.portfolio.country_code')}
                </CustomTypography>
              </TableCell>
              <TableCell sx={{ width: '25%' }}>
                <Stack alignItems="center" direction="row" spacing={0.5}>
                  <FlagIcon countryCode={countryCode.toLowerCase() as CountryIdentifier} />
                  <CustomTypography sx={{ lineHeight: 'inherit' }} variant="inherit">
                    {t(`common.country.${countryCode.toLowerCase() as CountryIdentifier}`)}
                  </CustomTypography>
                </Stack>
              </TableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  )
}

const RegulationObjectCard = ({ countryCode, regulationObjectCode }: RegulationObjectCardProps) => {
  if (!countryCode || !regulationObjectCode) {
    return null
  }

  return (
    <Card sx={{ marginY: 3 }}>
      <CustomCardContent>
        <RegulationObjectDetailTable countryCode={countryCode} regulationObjectCode={regulationObjectCode} />
      </CustomCardContent>
    </Card>
  )
}

export default RegulationObjectCard
